/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

export type CardAccountTransferResponseStatus = typeof CardAccountTransferResponseStatus[keyof typeof CardAccountTransferResponseStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CardAccountTransferResponseStatus = {
  pending: 'pending',
  posted: 'posted',
  declined: 'declined',
  void: 'void',
} as const;
